import Router from 'vue-router';
import { staticRoutes, pathMatch } from './modules/static';
import settings from 'settings';
import { dynamicRouter } from './lib/routing-table-tool';
import { setFilterMenu } from './lib/util';
import { getRouter } from './router-operation';

const { isRequestRoutes, publicPath, routerMode } = settings;

export function createRouter() {
    return new Router({
        base: publicPath,
        mode: routerMode,
        // mode: 'history', // require service support
        scrollBehavior: () => ({ y: 0 }),
        routes: staticRoutes,
    });
}

// 添加动态路由
export function setAddRoute(accessRoutes) {
    if (isRequestRoutes) {
        getRouter().addSelfRoutes([dynamicRouter(accessRoutes[0])]);
    } else {
        getRouter().addSelfRoutes(accessRoutes);
    }
}

// 初始化方法，防止刷新时丢失
export async function initDynamicRoute() {
    const accessRoutes = await setFilterMenu(); // 过滤权限菜单
    if (!accessRoutes) return false;
    // resetRouter(); // 重置路由器（2023年9月12日，迁移到 vite 之前这个注释就有）
    setAddRoute([accessRoutes, pathMatch]); // 添加动态路由
    return true;
}
